import ForgotPassword from './ForgotPassword'
import ResetPassword from './ResetPassword'
import Login from './Login'
import LoginExpert from './LoginExpert'
import EnableAccount from './EnableAccount'
import SsoConnection from './SsoConnection'

export default [{
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {showNavigation: false, bodyClass: '', title: 'Login'}
}, {
  path: '/expert/login',
  name: 'LoginExpert',
  component: LoginExpert,
  meta: {showNavigation: false, title: 'Login'}
}, {
  path: '/forgotPassword',
  name: 'ForgotPassword',
  component: ForgotPassword,
  meta: {showNavigation: false, bodyClass: '', title: 'Forgot Password'}
}, {
  path: '/resetPassword/:token',
  name: 'ResetPassword',
  component: ResetPassword,
  meta: {showNavigation: false, bodyClass: '', title: 'Reset Password'}
}, {
  path: '/confirmEmail/:token',
  name: 'ConfirmEmail',
  component: EnableAccount,
  meta: {showNavigation: false, bodyClass: '', title: 'Confirm Email'}
}, {
  path: '/sso/:provider?',
  name: 'SsoConnection',
  component: SsoConnection,
  props: true,
  meta: {showNavigation: false, bodyClass: '', title: 'Sso connection'}
}]



// WEBPACK FOOTER //
// ./src/pages/login/router.js